import { LoginForm } from 'components/LoginForm';

export const LoginPage = () => {
  return <LoginForm />;
};
